import { useTranslation } from 'react-i18next';

import { LineSeparator } from '@/components/LineSeparator';
import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { useIsCashCurrency } from '@/hooks/use-social-currency';
import { toSocialCurrency } from '@/utils/numeric/currency';

import { useSbkBetSlipStore } from '../../hooks/use-sbk-betslip-store';
import { betProfitBoostSelector } from '../../utils/betslip-selectors';

export const ProfitBoostDetails = ({ betId }: { betId: string }) => {
    const { t } = useTranslation('betslip_sbk');
    const isCashCurrency = useIsCashCurrency();
    const profitBoostAdded = useSbkBetSlipStore(betProfitBoostSelector(betId, isCashCurrency));
    const maxBonusAmount = useSbkBetSlipStore(state => state.selectedPromos[betId]?.metadata.MAX_PAYOUT_AMOUNT);

    const isMaxed = maxBonusAmount != null && profitBoostAdded >= maxBonusAmount;

    return (
        <Box mt="s10">
            <LineSeparator />
            <Row gap="s3" alignItems="center" mt="s10">
                <Text variant="labelMedium" color={ds.colorToken.text.brand}>
                    {t('profit_boost_added', {
                        amount: toSocialCurrency(profitBoostAdded),
                    })}
                    {isMaxed ? ` ${t('profit_boost_max_label')}` : ''}
                </Text>
                <Text variant="bodySmaller" color="neutral300" lineHeight={16}>
                    •
                </Text>
                <Text variant="bodySmaller" color="neutral300" lineHeight={16}>
                    {t('profit_boost_paid_in_bonus')}
                </Text>
            </Row>
        </Box>
    );
};
